'use client';

import { __makeTemplateObject, __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import { EApplyType } from '../../services/resumes/types.js';
import { OptionGroup } from '../../OptionGroup/index.js';
import { Paragraph } from '../../Typography/components/Variant.js';
import { dateToString, fileName } from '../helper.js';
import { colors } from '../../Colors/index.js';
import Button from '../../Button/index.js';
import { calculateProfileStrength } from '../../Utils/profileStrength.js';
import { getProfileLevel } from '../../QuickApplyJobModal/service.js';
import { ELanguage } from '../../Utils/constants.js';
import { isMobile, downloadAttachFile } from '../../Utils/helpers.js';
import { IS_RESUME_ATTACHMENT } from '../const.js';
import PDFIcon from '../../Images/PDFIcon/index.js';
import ThreeDotIcon from '../../Images/ThreeDotIcon/index.js';
import EditIcon from '../../icons/EditIcon.js';
import ResponsiveSheet from '../../ButtonViewMore/components/ResponsiveSheet/index.js';
import styled from 'styled-components';
import { OptionGroupStyled } from '../../OptionGroup/OptionGroup.style.js';
import EmployerViewIcon from '../../Images/EmployerViewIcon/index.js';
import EmployerViewProfileIcon from '../../Images/EmployerViewProfileIcon/index.js';

var RightButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    gap: 8px;\n    opacity: ", ";\n    ", ":hover & {\n        opacity: 1;\n    }\n"], ["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    gap: 8px;\n    opacity: ", ";\n    ", ":hover & {\n        opacity: 1;\n    }\n"])), function (props) { return props.active ? 1 : 0; }, OptionGroupStyled.Wrapper);
var CustomLabel = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n    span {\n        line-height: 24px;\n        padding: 5px 8px;\n        background: ", ";\n        border-radius: 14px;\n        color: ", ";\n        font-size: 12px;\n        &.profile-status {\n            background: ", ";\n            color: ", ";\n            margin-left: 6px;\n        }\n    }\n"], ["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n    span {\n        line-height: 24px;\n        padding: 5px 8px;\n        background: ", ";\n        border-radius: 14px;\n        color: ", ";\n        font-size: 12px;\n        &.profile-status {\n            background: ", ";\n            color: ", ";\n            margin-left: 6px;\n        }\n    }\n"])), colors.grey[20], function (_a) {
    var isDisable = _a.isDisable;
    return (isDisable ? 0.4 : 1);
}, colors.primary[95], colors.green[50], colors.neutral[95], colors.grey[20]);
var ProfileStatus = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    line-height: 14px;\n    padding: 5px 8px;\n    border-radius: 14px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    background: ", ";\n    color: ", ";\n"], ["\n    display: inline-block;\n    line-height: 14px;\n    padding: 5px 8px;\n    border-radius: 14px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    background: ", ";\n    color: ", ";\n"])), colors.neutral[95], colors.grey[20]);
var RadioGroup = function (_a) {
    var resumeSettingInfo = _a.resumeSettingInfo, field = _a.field, t = _a.t, baseUrl = _a.baseUrl, baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, lang = _a.lang, _b = _a.newResumeId, newResumeId = _b === void 0 ? -1 : _b;
    var _c = useState(), onlineProfile = _c[0], setOnlineProfile = _c[1];
    var _d = useState(), lastAttachments = _d[0], setLastAttachments = _d[1];
    var _e = useState(), moreOption = _e[0], setMoreOption = _e[1];
    var _f = useState([]), contentOption = _f[0], setcontentOption = _f[1];
    var _g = useState(''), titleOption = _g[0], setTitleOption = _g[1];
    var _h = useState(0), percent = _h[0], setPercent = _h[1];
    var percentProfileStrength = function (profileLevel) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // Note: profileStrength percent is processed from API
        if ((_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.profileStrength) {
            setPercent((_b = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength);
            return;
        }
        var profileLevelItem = {
            level: (_d = (_c = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _c === void 0 ? void 0 : _c.resumeLevelId) !== null && _d !== void 0 ? _d : 0,
            passedPoints: (_f = (_e = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _e === void 0 ? void 0 : _e.currentPoint) !== null && _f !== void 0 ? _f : 0,
            totalPoints: (_h = (_g = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _g === void 0 ? void 0 : _g.totalPoint) !== null && _h !== void 0 ? _h : 0,
            status: (_k = (_j = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _j === void 0 ? void 0 : _j.resumeStatus) !== null && _k !== void 0 ? _k : ''
        };
        var percent = (_l = calculateProfileStrength(profileLevelItem)) !== null && _l !== void 0 ? _l : 0;
        if (percent) {
            var parseIntPercent = parseInt(percent.toFixed(0));
            setPercent(parseIntPercent);
        }
    };
    var getProfileStrengthByProfileLevel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var profileLevel, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getProfileLevel(accessToken !== null && accessToken !== void 0 ? accessToken : '', lang !== null && lang !== void 0 ? lang : ELanguage.VI, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    profileLevel = _a.sent();
                    if (profileLevel) {
                        percentProfileStrength(profileLevel);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // options lastAttachment
    var memoListLastAttachment = useMemo(function () {
        if (!resumeSettingInfo || resumeSettingInfo.attributes.length < 1)
            return [];
        var attachCVs = resumeSettingInfo.attributes
            .filter(function (item) { return item.isAttach === IS_RESUME_ATTACHMENT; })
            .map(function (attachCV) { return attachCV; });
        return attachCVs === null || attachCVs === void 0 ? void 0 : attachCVs.map(function (item) {
            var _a, _b;
            var updatedText = "".concat(dateToString((_a = item.lastProcessedOn) !== null && _a !== void 0 ? _a : 0));
            return {
                id: item.id,
                name: fileName((_b = item.fileName) !== null && _b !== void 0 ? _b : ''),
                link: item.link,
                updatedText: updatedText,
                isNewUploadCV: newResumeId === item.id
            };
        });
    }, [resumeSettingInfo, field]);
    var handleOption = function (resumeId, resumeType) {
        if (!resumeId)
            return;
        setMoreOption(resumeType);
        if (resumeType === EApplyType.online) {
            setTitleOption(t('VietnamWorks online Profile'));
            var contentOption_1 = [{
                    label: t('Update profile'),
                    icon: React__default.createElement(EditIcon, { size: 21 }),
                    isCloseOnClick: true,
                    onClick: function () {
                        window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                    }
                }];
            if (onlineProfile && onlineProfile.allowSearchableDisplay === 1) {
                contentOption_1.push({
                    label: t('View as employer'),
                    icon: React__default.createElement(EmployerViewIcon, { width: 21, height: 21 }),
                    isCloseOnClick: true,
                    onClick: function () {
                        window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(resumeId), '_blank');
                    }
                });
            }
            setcontentOption(contentOption_1);
            return;
        }
        // For attachment
        var resumeAttachment = memoListLastAttachment.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === resumeId; })[0];
        setTitleOption(resumeAttachment ? resumeAttachment.name : '');
        setcontentOption([
            {
                label: t('View CV'),
                icon: React__default.createElement(PDFIcon, { width: 22, height: 22, className: 'pdf-icon', color: colors.grey[50] }),
                isCloseOnClick: true,
                onClick: function () {
                    var _a;
                    if (!(resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id)) {
                        return;
                    }
                    downloadAttachFile({
                        resumeId: resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id,
                        downloadRequest: 'new-window',
                        msBaseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                        accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                        fileName: (_a = resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.name) !== null && _a !== void 0 ? _a : ''
                    });
                }
            },
            {
                label: t('View as employer'),
                icon: React__default.createElement(EmployerViewProfileIcon, { width: 24, height: 24 }),
                isCloseOnClick: true,
                onClick: function () {
                    window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(resumeAttachment === null || resumeAttachment === void 0 ? void 0 : resumeAttachment.id), '_blank');
                }
            }
        ]);
    };
    var setOffToggleOption = function (value) {
        if (!value) {
            setMoreOption(undefined);
        }
    };
    useEffect(function () {
        var _a, _b;
        if (!resumeSettingInfo)
            return;
        var onlineProfile = (_a = resumeSettingInfo.attributes) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.isAttach !== IS_RESUME_ATTACHMENT; });
        var attachCVs = (_b = resumeSettingInfo.attributes) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.isAttach === 1; }).map(function (attachCV) { return attachCV; });
        setOnlineProfile(onlineProfile);
        setLastAttachments(attachCVs);
    }, [resumeSettingInfo]);
    useEffect(function () {
        if (accessToken) {
            getProfileStrengthByProfileLevel();
        }
    }, [accessToken]);
    var renderDescription = function () {
        return (React__default.createElement(React__default.Fragment, null,
            isMobile() && !(onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) ? (React__default.createElement(ProfileStatus, null, t('Not approved'))) : null,
            (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.updatedDate) ? (React__default.createElement(Paragraph, { size: isMobile() ? 'small' : 'medium', color: colors.grey[60], style: { marginBottom: 6 } },
                t('Updated'),
                ": ",
                dateToString(onlineProfile.updatedDate),
                React__default.createElement("span", null, " - "),
                percent ? "".concat(percent, "% ").concat(t('completed')) : null)) : ('')));
    };
    var renderDescriptionAttach = function (cv) {
        return (cv === null || cv === void 0 ? void 0 : cv.updatedText) ? (React__default.createElement(Paragraph, { size: isMobile() ? 'small' : 'medium', color: colors.grey[60], style: { marginBottom: 6 } },
            t('Updated'),
            ": ",
            cv.updatedText)) : null;
    };
    var onChange = function (type, id) {
        field.onChange({
            type: type,
            id: id
        });
        field.setFieldValue('resumeApply', type);
    };
    var renderListAttachment = function () {
        return memoListLastAttachment.map(function (item, index) {
            var _a, _b;
            return (React__default.createElement(OptionGroup, { key: "".concat(item.id, "_").concat(index), value: "".concat(EApplyType.lastAttachment, "-").concat(item.id), checked: ((_a = field === null || field === void 0 ? void 0 : field.value) === null || _a === void 0 ? void 0 : _a.id) === item.id, name: 'apply-type', onChange: function (value) {
                    if (item.id) {
                        onChange(value, item.id);
                    }
                }, label: React__default.createElement(CustomLabel, null,
                    item.name,
                    " ",
                    !isMobile() && (item === null || item === void 0 ? void 0 : item.isNewUploadCV) ? (React__default.createElement("span", null, t('Just uploaded'))) : null), styles: { wrapperStyle: {} } },
                renderDescriptionAttach(item),
                React__default.createElement(RightButtonWrapper, { active: ((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.id) === item.id }, !isMobile() ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Button, { type: 'info', size: 'sm', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            if (!(item === null || item === void 0 ? void 0 : item.id)) {
                                return;
                            }
                            var body = (item === null || item === void 0 ? void 0 : item.isNewUploadCV) ? { type: 2 } : null;
                            downloadAttachFile({
                                resumeId: item === null || item === void 0 ? void 0 : item.id,
                                downloadRequest: 'new-window',
                                msBaseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                                accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                                fileName: item === null || item === void 0 ? void 0 : item.name,
                                body: body
                            });
                        } }, t('View CV')),
                    React__default.createElement(Button, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(item === null || item === void 0 ? void 0 : item.id), '_blank');
                        } }, t('View as employer')))) : (React__default.createElement(ThreeDotIcon, { onClick: function () { return handleOption(item.id || 0, EApplyType.attachment); } })))));
        });
    };
    var renderOnlineProfile = function () {
        var _a, _b, _c;
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Paragraph, { size: 'medium', color: colors.grey[20], style: { marginBottom: 8, fontWeight: 500 } }, t('By Vietnamworks profile')),
            (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) === 1 ? (React__default.createElement(OptionGroup, { value: EApplyType.online, checked: ((_a = field === null || field === void 0 ? void 0 : field.value) === null || _a === void 0 ? void 0 : _a.type) === EApplyType.online, name: 'apply-type', onChange: function (value) {
                    if (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) {
                        onChange(value, onlineProfile.id);
                    }
                }, label: t('VietnamWorks online Profile') },
                renderDescription(),
                React__default.createElement(RightButtonWrapper, { active: ((_b = field === null || field === void 0 ? void 0 : field.value) === null || _b === void 0 ? void 0 : _b.type) === EApplyType.online }, !isMobile() ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Button, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                        } }, t('Update profile')),
                    React__default.createElement(Button, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('preview-resume/')).concat(onlineProfile.id), '_blank');
                        } }, t('View as employer')))) : (React__default.createElement(ThreeDotIcon, { onClick: function () { return handleOption(onlineProfile.id || 0, EApplyType.online); } }))))) : (React__default.createElement(OptionGroup, { disabled: true, contentDisable: false, value: EApplyType.online, checked: ((_c = field === null || field === void 0 ? void 0 : field.value) === null || _c === void 0 ? void 0 : _c.type) === EApplyType.online, name: 'apply-type', onChange: function (value) {
                    if (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) {
                        onChange(value, onlineProfile.id);
                    }
                }, customLabel: React__default.createElement(CustomLabel, { style: { opacity: 1 } },
                    t('VietnamWorks online Profile'),
                    " ",
                    isMobile() ? null : (React__default.createElement("span", { className: 'profile-status' }, t('Not approved')))) },
                renderDescription(),
                React__default.createElement(RightButtonWrapper, { active: true }, !isMobile() ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Button, { size: 'sm', type: 'info', outline: 'outline', onClick: function (e) {
                            e.stopPropagation();
                            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
                        } }, t('Update profile')))) : (React__default.createElement(ThreeDotIcon, { onClick: function () { return handleOption((onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.id) || 0, EApplyType.online); } })))))));
    };
    return (React__default.createElement(React__default.Fragment, null,
        onlineProfile && (onlineProfile === null || onlineProfile === void 0 ? void 0 : onlineProfile.allowSearchableDisplay) === 1 ? renderOnlineProfile() : null,
        lastAttachments && lastAttachments.length > 0 ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Paragraph, { size: 'medium', color: colors.grey[20], style: { marginBottom: 8, fontWeight: 500 } }, t('By attached CVs')),
            renderListAttachment())) : null,
        isMobile() && moreOption ? (React__default.createElement(ResponsiveSheet, { isShow: !!moreOption, header: titleOption, options: contentOption, textOptions: { closeText: t('Cancel') }, responsiveButton: {
                type: 'default'
            }, sheetStyles: { zIndex: 1100 }, setIsShow: setOffToggleOption })) : null));
};
var RadioGroup$1 = React__default.memo(RadioGroup);
var templateObject_1, templateObject_2, templateObject_3;

export { RadioGroup, RadioGroup$1 as default };
//# sourceMappingURL=RadioGroup.js.map
